import "./image-viewer.scss";

export const reCreateImagePreviewIfBlob = (
  specimen: string | File | undefined
) => {
  if (typeof specimen === "object" && typeof specimen?.["name"] === "string") {
    const blobEntity = URL.createObjectURL(specimen);
    return blobEntity;
  }

  return "";
};

export interface ImageViewerProps {
  image?: string | File;
  className?: string;
}

export function ImageViewer({ image, className }: ImageViewerProps) {
  if (!image) {
    return <div>No Image</div>;
  }

  if (typeof image === "string") {
    return <img src={image} className={className} />;
  }

  const imageFilePreview = reCreateImagePreviewIfBlob(image);

  return <img src={imageFilePreview} className={className} />;
}

export default ImageViewer;
